import { createAction as makeActionCreator } from 'redux-actions';

import { sessionTimeOut } from './session';

import { checkAppUpdate } from '../util/helpers';

export const genericError = makeActionCreator('GENERIC_ERROR_OCCURRED');

export const getErrorMessage = (error) => {
  if (error.response && error.response.data && error.response.data.message) {
    // Use .trim(), as server returns the error code followed by carriage return...
    // At least with invalid reservation code.
    return error.response.data.message.trim
    ? error.response.data.message.trim()
    : error.response.data.message;
  }
  return error;
};

export const handleError = dispatch => (actionOrError) => {
  // We accept either an error or an action with the error in the payload.
  const error = actionOrError.payload || actionOrError;
  // check for app updates
  if (error.response) {
    checkAppUpdate(error.response);
  }
  if (error.response && error.response.status === 401) {
    dispatch(sessionTimeOut());
  } else {
    // If an action was sent, dispatch it. If an error was sent, create a new action to dispatch.
    dispatch(actionOrError.payload ? actionOrError : genericError(getErrorMessage(error)));
  }
};



// WEBPACK FOOTER //
// ./src/actions/errors.js